import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { MESSAGE_CONTENT_TYPE_ATTRIBUTE, MessageContentType } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import LinkPreview from './LinkPreview/LinkPreview';

interface ITextProps {
  message: ChatMessage;
  isView?: boolean;
}

export const Text: FC<ITextProps> = observer(({ message, isView }) => {
  const { text, linkPreview } = message.renderPayload;

  if (!text) {
    return null;
  }

  return (
    <>
      <div {...{ [MESSAGE_CONTENT_TYPE_ATTRIBUTE]: MessageContentType.Text }}>
        <QuotedSelectionHighlight
          originalText={text}
          highlightedText={message.highlightedText}
          groupId={message.payload.message.groupId}
          isView={isView}
        >
          <TextRenderer
            userMentions={message.payload.userMentions}
            hasBotCommands={message.payload.message.group.isBot}
            keyWords={message.payload.keyWords}
            groupId={message.payload.message.groupId}
          >
            {text}
          </TextRenderer>
        </QuotedSelectionHighlight>
      </div>
      {linkPreview && (
        <LinkPreview
          data={linkPreview}
          messageId={message.id}
        />
      )}
    </>
  );
});
